import CosmoBaseHero from "./components/hero/index.vue";
import CosmoBaseStats from "./components/stats/index.vue";
import CosmoBasePlans from "./components/plans/index.vue";
import CosmoBaseExperts from "./components/experts/index.vue";
import CosmoBaseBanner from "./components/banner/index.vue";
import CosmoBaseSlider from "./components/slider/index.vue";
import CosmoBaseFaq from "./components/faq/index.vue";
import CosmoBaseForm from "./components/form/index.vue";
import { mapActions, mapGetters } from "vuex";
import { globalLoader } from "../../helpers/variables";


export default {
  name: "CosmoBasePage",
  props: {},
  emits: [],
  components: {
    CosmoBaseFaq,
    CosmoBaseExperts,
    CosmoBaseHero,
    CosmoBaseStats,
    CosmoBasePlans,
    CosmoBaseBanner,
    CosmoBaseSlider,
    CosmoBaseForm,
  },
  setup() {
  },
  data() {
    return {};
  },
  async created() {
    globalLoader(true);
    try {
      await this.fetchCosmobasePage();
    } catch (e) {
      window.location.href = "/";
    } finally {
      globalLoader(false);
    }
  },
  mounted() {
  },
  watch: {},
  computed: {
    ...mapGetters({
      content: "cosmobase/content",
    }),
  },
  methods: {
    ...mapActions({
      fetchCosmobasePage: "cosmobase/FETCH_COSMOBASE_PAGE",
    }),
  },
};
